document.addEventListener("DOMContentLoaded", async () => {
    const scrollers = document.querySelectorAll(".wp-block-klingit-basic-scroller");
    const debounce = (func, delay) => {
        let inDebounce;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(() => func.apply(context, args), delay);
        };
    };
    for (const scroller of scrollers) {
        const scrollerSections = scroller.querySelectorAll(".splide__list > .wp-block-group");

        scrollerSections.forEach(section => {
            section.classList.add("splide__slide");
        });

        const speed = scroller.getAttribute('data-speed');
        const pause = scroller.getAttribute('data-hover-pause');
        let gap = scroller.getAttribute('data-gap');
        if (gap) {
            if (gap.includes('var')) {
                gap = `var(--wp${gap.replace(/\|/g, '--').replace(/var:/g, '--')})`;
            }
        } else {
            gap = '24px';
        }

        const splideInstance = new Splide(scroller, {
            pagination: false,
            arrows: false,
            type: 'loop',
            drag: 'free',
            autoWidth: scrollerSections.length === 1 ? false : true,
            autoScroll: {
                speed: speed,
                pauseOnHover: pause === "false" ? false : true,
                pauseOnFocus: pause === "false" ? false : true,
            },
            gap: gap
        });
        const updateClones = async () => {
            let width = 0;
            scrollerSections.forEach(section => {
                width += section.getBoundingClientRect().width;
            });

            const windowWidth = window.innerWidth;
            const clonesNeeded = width === 0 ? 1 : Math.ceil(windowWidth / width);

            splideInstance.options = {
                clones: scrollerSections.length * clonesNeeded
            };
            await splideInstance.refresh();
        };

        let previousWidth = window.innerWidth;

        const debouncedUpdateClones = debounce(() => {

            const currentWidth = window.innerWidth;

            if (currentWidth !== previousWidth) {
                updateClones();
                previousWidth = currentWidth;
            }
        }, 500);


        window.addEventListener('resize', debouncedUpdateClones);

        try {
            await Promise.all([splideInstance.mount(window.splide.Extensions), updateClones()]);
        } catch (error) {
            console.error("Error mounting Splide:", error);
        }
    }
});
